import {WriteButton} from '../../common/buttons/WriteActions';
import {Add as AddIcon} from '@mui/icons-material';
import {Box, FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import {GuidLightDto} from '../../../models/common/IGuidLight';
import {useState} from 'react';
import {CreateProductTypeDialog} from './CreateProductTypeDialog';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';

interface Props {
    productTypes: GuidLightDto[] | undefined;
    value: string | null;
    onChange: (productTypeId: string | null) => void;
}

export const ProductTypeSelect = ({productTypes, value, onChange}: Props) => {
    const {t} = useAppTranslation();
    const [isCreateOpen, setIsCreateOpen] = useState(false);

    return (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', minWidth: 235}}>
            <FormControl size="small" sx={{minWidth: 235, flexGrow: 1}}>
                <InputLabel id="product-type-label">{t('settings:product_type')}</InputLabel>
                <Select
                    labelId="product-type-label"
                    label={t('settings:product_type')}
                    value={value ?? ''}
                    onChange={(event) => onChange(event.target.value || null)}
                >
                    <MenuItem value="">{t('recipes:uncategorized')}</MenuItem>
                    {(productTypes || []).map((productType) => (
                        <MenuItem key={productType.id} value={productType.id}>{productType.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <WriteButton size="small" startIcon={<AddIcon/>} onClick={() => setIsCreateOpen(true)}>
                {t('recipes:create_product_type')}
            </WriteButton>
            <CreateProductTypeDialog
                open={isCreateOpen}
                onClose={() => setIsCreateOpen(false)}
                onCreated={(productType) => {
                    onChange(productType.id);
                    setIsCreateOpen(false);
                }}
            />
        </Box>
    );
};
